// When using @shared
// import '@specsguard/shared/src/construction.helpers.js';
// import * as ElementHelpers from '@specsguard/shared/src/element.helpers.js';
// import * as GeneralHelpers from '@specsguard/shared/src/general.helpers.js';
// import * as TranslateHelpers from '@specsguard/shared/src/translate.helpers.js';
// import * as AreaInheritanceHelper from '@specsguard/shared/src/area-inheritance.helpers.js';

// Without using @shared
import '../app-legacy/helpers/construction.helpers.js';
import * as ElementHelpers from '../app-legacy/helpers/element.helpers.js';
import * as GeneralHelpers from '../app-legacy/helpers/general.helpers.js';
import * as TranslateHelpers from '../app-legacy/helpers/translate.helpers.js';
import * as AreaInheritanceHelper from '../app-legacy/helpers/area-inheritance.helpers.js';

declare var angular: angular.IAngularStatic;


(function () {
  angular
    .module('specsguardApp')
    .factory('sgTranslateHelpers', sgTranslateHelpers);

  function sgTranslateHelpers() {
    return TranslateHelpers.TranslateHelpers;
  }


  angular
    .module('specsguardApp')
    .factory('sgGeneralHelpers', sgGeneralHelpers);

  function sgGeneralHelpers() {
    return GeneralHelpers.GeneralHelpers;
  }


  angular
    .module('specsguardApp')
    .factory('sgElementHelpers', sgElementHelpers);

  function sgElementHelpers() {
    return ElementHelpers.ElementHelpers;
  }


  angular
    .module('specsguardApp')
    .factory('sgAreaInheritanceHelpers', sgAreaInheritanceHelpers);

  sgAreaInheritanceHelpers.$inject = ['sgAutocompleteHelpers', 'Labels', 'Constants',
    'EditorConfig', 'Utils', 'Auth'];

  function sgAreaInheritanceHelpers(sgAutocompleteHelpers, Labels, Constants, EditorConfig, Utils, Auth) {
    AreaInheritanceHelper.AreaInheritanceHelper.Constants = Constants;
    return AreaInheritanceHelper.AreaInheritanceHelper;
  }

})();


